var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCirclePlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.12918C8.44387 3.12918 3.12912 8.44394 3.12912 15C3.12912 21.5561 8.44387 26.8709 15 26.8709C21.556 26.8709 26.8708 21.5561 26.8708 15C26.8708 8.44394 21.556 3.12918 15 3.12918ZM1.87079 15C1.87079 7.74898 7.74892 1.87085 15 1.87085C22.251 1.87085 28.1291 7.74898 28.1291 15C28.1291 22.2511 22.251 28.1292 15 28.1292C7.74892 28.1292 1.87079 22.2511 1.87079 15Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8749 15.6292H8.12494V14.3708H21.8749V15.6292Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3708 21.875V8.125H15.6291V21.875H14.3708Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCirclePlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle_plus.59bf5f81593c8a637bd4e19a410ecb80.svg";